import { DataGrid } from "@mui/x-data-grid";
import { TableLoadingOverlay } from "../feedback/TableLoadingOverlay";

export function SoftDataGrid({
  height = "calc(100vh - 170px)",
  loading = false,
  ...props
}) {
  return (
    <DataGrid
      loading={loading}
      rowHeight={42}
      columnHeaderHeight={38}
      pageSizeOptions={[10, 25, 50, 100]}
      disableRowSelectionOnClick
      slots={{
        loadingOverlay: TableLoadingOverlay,
      }}
      slotProps={{
        loadingOverlay: {
          variant: "circular-progress",
          noRowsVariant: "circular-progress",
        },
      }}
      sx={{
        height,
        position: "relative",

        border: "1px solid #E3E7EC",
        borderRadius: 0,
        bgcolor: "#FFFFFF",

        "& .MuiDataGrid-overlayWrapper": {
          minHeight: "320px !important",
        },

        "& .MuiDataGrid-overlayWrapperInner": {
          position: "relative",
          minHeight: "320px !important",
        },

        "& .MuiDataGrid-columnHeaders": {
          bgcolor: "#FAFBFC",
          borderBottom: "1px solid #DCE2E8",
        },

        "& .MuiDataGrid-columnHeader": {
          borderRight: "1px solid #EDF0F3",
        },

        "& .MuiDataGrid-columnHeaderTitle": {
          color: "#5F6B7A",
          fontSize: "0.67rem",
          fontWeight: 800,
          textTransform: "uppercase",
        },

        "& .MuiDataGrid-cell": {
          fontSize: "0.72rem",
          borderRight: "1px solid #F0F2F5",
          borderBottom: "1px solid #E8ECF0",
        },
      }}
      {...props}
    />
  );
}